import React, { Fragment } from 'react';
import AssetHierarchyImportContainer from './import/components/AssetHierarchyImportContainer';
import AssetHierarchyManagementContainer from './list/components/AssetHierarchyManagementContainer';
import Header from './header/Header';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { withAreaGetter } from 'providers/AreasConsumers';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_ASSET_HIERARCHY } from 'constants/rightsCodes';

const AssetHierarchyPage = ({ getElemByAreaKey }) => {
  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_ASSET_HIERARCHY}>
        <AssetHierarchyImportContainer />
        <AssetHierarchyManagementContainer />
      </PermissionCheck>
    </Fragment>
  );
};

AssetHierarchyPage.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(AssetHierarchyPage);
